<template>
    <div>
        <div class="content-heading">
            <i class="ic-head-icon">
                <img src="@/assets/images/sidebar/customer.svg" alt="Rewards Icon">
            </i>
            <h4 class="head-title">
                <template v-if="planId != 5">
                    Customers
                </template>
                <template v-else>
                    Transactions
                </template>
            </h4>
            <i class="ic-tooltip" id="help"></i>
            <b-popover target="help"
                    triggers="hover"
                    :content="planId != 5 ? 'Manage your customers information, transaction and feedback on this section.' : 'Manage your redeemed rewards, revenue and transaction information on this section.'">
            </b-popover>
            <app-tab :tabs="tabs" :merchantUuid="merchantUuid"></app-tab>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import { mapState } from "vuex";
import AppTabs from "@/components/common/AppTabs.vue";
const tabs = [
    {
        name: "Transaction History",
        href: "/customers/transaction-history",
        access: "customers.transaction-history"
    },
    {
        name: "Customized Transaction History",
        href: "/customers/customized-transaction-history",
        access: "customers.transaction-history"
    }
];
const whitelistTab = {
    name: "Whitelist",
    href: "/customers/whitelist",
    access: "customers.whitelist:topup-whitelist"
};
const allowedTabs = [
    {
        name: "Customers",
        href: "/customers/list",
        access: "customers.customers"
    },
    {
        name: "Feedbacks",
        href: "/customers/feedbacks",
        access: "customers.feedbacks"
    },
    {
        name: "Target Segment",
        href: "/customers/target-segment",
        access: "customers.target-segment"
    },
    {
        name: "Hotline",
        href: "/customers/hotline",
        access: "customers.hotline"
    },
    {
        name: "Key Account",
        href: "/customers/key-account",
        access: "customers.key-account"
    } 
];
export default {
    name: "Customers",
    components: {
        "app-tab": AppTabs
    },
    data() {
        return {
            tabs: tabs,
            whitelistTab: whitelistTab,
            allowedTabs: allowedTabs,
            whitelist: null,
            keyAccountsUuid: {
              local: [
                "8e9bc0ba-aa25-4c75-96d5-b16703916b35", // estore
                "5f34dbaf-93e0-46bd-9779-777b7cfccc30", // generika
              ],
              Development: [
                "8e9bc0ba-aa25-4c75-96d5-b16703916b35", //estore
              ],
              Canary: [
                "8e9bc0ba-aa25-4c75-96d5-b16703916b35", // estore
                "5f34dbaf-93e0-46bd-9779-777b7cfccc30", // generika
              ],
              Staging: [
                "90dd82f7-0e39-430c-9647-cdf7e3741708", // generika
              ],
              Release: [
                "d52635e6-5363-4f7b-9119-d5c64fad8a09", // estore
                // "e07df259-aae6-4ea8-b507-b07f08131727", // generika
              ],
              Production: [
                "d52635e6-5363-4f7b-9119-d5c64fad8a09", // estore
                // "e07df259-aae6-4ea8-b507-b07f08131727", // generika
              ],
            },
        };
    },
    computed: {
        ...mapState("auth", ["enabledTopUps", "planId"]),
        ...mapState("customers", ["merchantUuid"])
    },
    created: function() {
        // Checks if user is Marketplace Plan
        if (this.planId != 5) {
            allowedTabs.forEach(tab => {
                if (!tabs.includes(tab)) {
                    tabs.push(tab);
                }
            });
        }

        // Check if EstoreCod or Generika
        let keyAccount = this.keyAccountsUuid[process.env.VUE_APP_MODE].find(uuid => uuid == this.merchantUuid)
        if(keyAccount == undefined) {
            tabs.splice(-1, 1)
        }

        this.getWhitelist();
    },
    methods: {
        getWhitelist: async function() {
            let _this = this;
            await this.$store.dispatch("auth/getTopUps").then(function() {
                _this.whitelist = _this.enabledTopUps.includes("whitelist");
                switch (_this.whitelist) {
                    case true:
                        if (!tabs.includes(whitelistTab)) {
                            tabs.push(whitelistTab);
                        }
                        break;
                }
            });
        }
    }
};
</script>
